<header-ui
    [userDialogView]="userDialogView"
    (userDialogViewEvent)="userDialogViewEvent($event)"></header-ui>
<div #userDialogVCR></div>
<router-outlet></router-outlet>
